import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setUserProductCategories } from "../../redux/Actions/productCategoriesAction";
import { setCartCount, deleteCartCount } from "../../redux/Actions/cartCountAction";
import { setValue } from "../../utility";
import "./SectionCategoriesThemeThree.css";

const base_url = process.env.REACT_APP_BACKEND_URL;

function SectionCategoriesThemeThree() {
  const [categories, setCategories] = useState<any[]>([]);
  const [active, setActive] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch<any>();
  const settings: any = useSelector<any>((state) => state.settings);
  const currency = settings?.WebmasterSettings?.currency || "£";
  const selectedCategories: any = useSelector<any>((state) => state.userSelectedCategories);
  const { cartCount }: any = useSelector<any>((state) => state);

  useEffect(() => {
    const headers = {
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    axios
      .get(`${base_url}/api/get_categories?group_id=1`, { headers })
      .then((e) => {
        const list = e.data?.data?.category || [];
        setCategories(list);
        if (list.length) setActive(list[0].main_category_name);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  // --- cart helpers ---
  const findCategory = (list: any[], mainId: any) =>
    list?.find((c: any) => String(c.main_category_id) === String(mainId));

  const getQuantity = (mainCategory: any, subCategory: any) => {
    const cat = findCategory(
      Array.isArray(selectedCategories) ? selectedCategories : [],
      mainCategory.main_category_id
    );
    const sub = cat?.sub_categories?.find(
      (s: any) => String(s.sub_category_id) === String(subCategory.sub_category_id)
    );
    return parseInt(sub?.quantity || "0");
  };

  const updateCart = (mainCategory: any, subCategory: any, delta: number) => {
    const mainId = String(mainCategory.main_category_id);
    const subId = String(subCategory.sub_category_id);
    let list: any[] = Array.isArray(selectedCategories) ? [...selectedCategories] : [];

    let cat = findCategory(list, mainId);
    if (!cat) {
      cat = { ...mainCategory };
      list = [...list, cat];
    }

    let subs: any[] = cat.sub_categories ? [...cat.sub_categories] : [];
    let sub = subs.find((s: any) => String(s.sub_category_id) === subId);
    if (!sub) {
      sub = { ...subCategory, quantity: "0" };
      subs = [...subs, sub];
    }

    const currentQty = parseInt(sub.quantity || "0");
    const newQty = Math.max(0, currentQty + delta);
    if (newQty === currentQty) return;

    const updatedCat = {
      ...cat,
      sub_categories: subs.map((s: any) =>
        String(s.sub_category_id) === subId ? { ...s, quantity: String(newQty) } : s
      ),
    };
    const updatedList = list.map((c: any) =>
      String(c.main_category_id) === mainId ? updatedCat : c
    );

    dispatch(setUserProductCategories(updatedList));
    dispatch(delta > 0 ? setCartCount(cartCount + 1) : deleteCartCount(1));

    const cartInformationData = updatedList.filter((c: any) =>
      c.sub_categories?.some((s: any) => parseInt(s.quantity) > 0)
    );
    setValue("cartInformationData", cartInformationData);
    localStorage.removeItem("is_removed");
  };

  const activeCategory = categories.find((c) => c.main_category_name === active);

  if (!loading && !categories.length) return null;

  return (
    <div className="s3cat" id="pricing">
      <div className="s3cat__inner">
        <div className="s3cat__head">
          <span className="s3cat__eyebrow">Our Services</span>
          <h2 className="s3cat__title">Pricing List</h2>
        </div>

        {loading ? (
          <div className="s3cat__state">
            <div className="s3cat__spinner" />
            Loading pricing…
          </div>
        ) : (
          <>
            <div className="s3cat__tabs">
              {categories.map((category: any, i: number) => (
                <button
                  key={i}
                  type="button"
                  className={
                    active === category.main_category_name
                      ? "s3cat__tab is-active"
                      : "s3cat__tab"
                  }
                  onClick={() => setActive(category.main_category_name)}
                >
                  {category.main_category_name}
                </button>
              ))}
            </div>

            {activeCategory && (
              <div className="s3cat__panel">
                {(activeCategory.sub_categories || []).map(
                  (sub: any, si: number) => {
                    const qty = getQuantity(activeCategory, sub);
                    return (
                      <div
                        className="s3cat__card"
                        key={si}
                        title={(sub.options || [])
                          .filter((o: any) => o.is_default == "1")
                          .map(
                            (o: any) =>
                              `${o.option_description} : ${o.option_price}`
                          )
                          .join(", ")}
                      >
                        <span className="s3cat__card-name">
                          {sub.sub_category_name}
                        </span>
                        <hr className="s3cat__card-divider" />
                        <span className="s3cat__card-price">
                          {currency}{sub.total_price}
                        </span>
                        <div className="s3cat__card-footer">
                          {qty > 0 ? (
                            <span className="s3cat__stepper">
                              <button
                                type="button"
                                className="s3cat__step-btn"
                                aria-label="Remove one"
                                onClick={() => updateCart(activeCategory, sub, -1)}
                              >
                                &minus;
                              </button>
                              <span className="s3cat__step-qty">{qty}</span>
                              <button
                                type="button"
                                className="s3cat__step-btn"
                                aria-label="Add one"
                                onClick={() => updateCart(activeCategory, sub, 1)}
                              >
                                +
                              </button>
                            </span>
                          ) : (
                            <button
                              type="button"
                              className="s3cat__add-btn"
                              onClick={() => updateCart(activeCategory, sub, 1)}
                            >
                              Add to Cart
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            )}

            {cartCount > 0 && (
              <div className="s3cat__cart-bar">
                <button
                  type="button"
                  className="s3cat__go-cart-btn"
                  onClick={() => {
                    const cdcart = document.getElementById("cd-cart");
                    const cartoverlay = document.getElementById("cd-shadow-layer");
                    if (cdcart && cartoverlay) {
                      cdcart.classList.add("speed-in");
                      cartoverlay.classList.add("is-visible");
                    }
                  }}
                >
                  <svg
                    className="s3cat__cart-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="9" cy="21" r="1" />
                    <circle cx="20" cy="21" r="1" />
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                  </svg>
                  Go to Cart
                  <span className="s3cat__cart-badge">{cartCount}</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SectionCategoriesThemeThree;
